import axios from 'axios';

const serverEndpoint = window.location.origin.includes("localhost") ? "http://localhost:5099/api" : `${window.location.origin}/api` ;

const API = axios.create({
    baseURL: serverEndpoint
});


// For JWT

// API.interceptors.request.use(function (config) {
//     const token = localStorage.getItem('accessToken');
//     if(token){
//       config.headers.Authorization = `Bearer ${token}`;
//      }
//     return config;
// });

// API.interceptors.response.use(
//     (response) => {
//       return response;
//     },
//     async (error) => {
//       const originalRequest = error.config;
      
//       // Only attempt refresh on 401 Unauthorized responses
//       if (error.response?.status === 401 && !originalRequest._retry) {
//         originalRequest._retry = true;
//         const refreshToken = localStorage.getItem('refreshToken');
        
//         if (refreshToken) {
//           console.log('Attempting token refresh...');
//           try {
//             const response = await axios.post(`${serverEndpoint}auth/refresh`, {}, {
//               headers: {
//                 'Authorization': `Bearer ${refreshToken}`
//               }
//             });
            
//             if (response.data && response.data.data && response.data.data.access_token) {
//               const newAccessToken = response.data.data.access_token;
//               localStorage.setItem('accessToken', newAccessToken);
//               originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
              
//               console.log('Token refreshed successfully, retrying original request');
//               return API(originalRequest);
//             } else {
//               throw new Error('No access token in refresh response');
//             }
            
//           } catch (refreshError) {
//             console.log('Refresh failed:', refreshError.response?.data || refreshError.message);
//             localStorage.removeItem('accessToken');
//             localStorage.removeItem('refreshToken');
//             window.location.href = '/login';
//           }
//         } else {
//           console.log('No refresh token available');
//           localStorage.removeItem('accessToken');
//           window.location.href = '/login';
//         }
//       }
//       return Promise.reject(error);
//     }
//   );

export default API;